import { ABEventList } from '../lib/ab/event';
import { ABScreen } from '../lib/ab/screen';
import { aTrackPage } from '../lib/mdl/a-track';
import { cEventsHomeListViewActiveByProducerSlug } from '../lib/mdl/c-event-home';
import { $el } from '../lib/ui/elements';
import { UIViewSpec } from '../lib/ui/view';
import { HomeMenu } from './menu';

export class HomeProducerScreen extends ABScreen {
    constructor(private _slug: string) {
        super({ menu: new HomeMenu });
    }

    protected override async fillContent(content: UIViewSpec) {
        const { producer_id, producer_name, events } = await cEventsHomeListViewActiveByProducerSlug(this._slug);

        content.ui_add($el.SECTION('w-block', [
            $el.P('bigtitle', producer_name),
            $el.DIV('s-small'),
            new ABEventList('producer', 'list', 'event', events, { filter: 'active', sort: 'date' })
        ]));

        aTrackPage('producer', { producer: producer_id });
    }
}
